import axios from 'axios';
import store from '../store/index';
import { API } from '@/main';
import { logout } from './helpers'
import { Notification } from 'element-ui'
import router from '@/router/index'

export const axiosInstance = axios.create({
    baseURL: API
})

axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
axiosInstance.interceptors.request.use(req => {

    const token = localStorage.getItem('authToken');
    req.headers.Authorization = `Bearer ${token}`;
    return req
});

axiosInstance.interceptors.response.use(res => {
    console.log(res);
    
    return res
}, err => {
     if (err.response) {
        if (err.response.status === 401) {
            Notification.error({
                title: 'Error',
                message: 'You do not have access to this data.'
            })
            throw err
            
        } else if (err.response.status === 403) {
            Notification.warning({
                title: 'Warning',
                message: 'Authorization Token Expired. You have to login again.'
            })
            logout(router.currentRoute)
        } else {
            Notification.warning({
                title: 'Warning',
                message: 'An error has occured.'
            })
        } 
    } else {
        Notification.warning({
            title: 'Warning',
            message: 'An error has occured.'
        })

        window.location.reload()
    }
    return Promise.reject(err.response);
});



// WEBPACK FOOTER //
// ./src/helpers/axiosInterceptor.js